import * as React from 'react';
import Box from '@mui/material/Box';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme();

export default function Flyer(props) {
	return (
				
				
						<Box component="img" 
							 alt="Bienvenue sur le site d'inscription en ligne"
							 src={props.name}
							 sx={{
								width:['100px','200px','300px','400px','500px'],
								px:2
								}}>
					</Box>
					);
}